module.exports = __webpack_public_path__ + "img/green-add.b9b6d26a.svg";